export enum EOptions {
    Yes,
    No,
    Maybe,
}
